import { render } from "./UpdateMainInfo.vue?vue&type=template&id=3ffcaf53&scoped=true"
import script from "./UpdateMainInfo.vue?vue&type=script&lang=js"
export * from "./UpdateMainInfo.vue?vue&type=script&lang=js"

import "./UpdateMainInfo.vue?vue&type=style&index=0&id=3ffcaf53&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffcaf53"]])

export default __exports__